import { getRequest } from '@/api/request';

export const getArchitectureTree = async () => getRequest({ url: '/jobprofile/architecture/tree' });

export const getProfilesByUlids = async (ulids) => {
  const listOfUlids = Array.isArray(ulids) ? ulids : [];
  const params = new URLSearchParams();

  listOfUlids.forEach((ulid) => params.append('ulids[]', ulid));

  return getRequest({ url: `/jobprofile/architecture/profiles?${params.toString()}` });
};
